import { Button } from "@design-system/Button/Button";
import styles from "./AccrualDocumentImporter.module.scss";

interface Props {
    canCreate: boolean;
    createButtonLabel: string;
    onCreate: () => void;
    disabled?: boolean;
}

export const AccrualImporterCounterpartyAction: React.FC<Props> = ({
    canCreate,
    createButtonLabel,
    onCreate,
    disabled = false,
}) => {
    if (!canCreate) {
        return null;
    }

    return (
        <Button
            variant="primary"
            size="sm"
            onClick={onCreate}
            disabled={disabled}
            className={styles.createCounterpartyButton}
        >
            {createButtonLabel}
        </Button>
    );
};
